import React, { useState } from 'react'
import { SelectButton } from 'primereact/selectbutton';

type Props = {
  encodeOn: boolean;
  setEncodeOn: (option: boolean) => void;
  handleEncodeDecodeSwitch: () => void;
}

const SubmitButton = ({encodeOn, setEncodeOn, handleEncodeDecodeSwitch}: Props) => {
  const options: string[] = ['Encode', 'Decode'];
  const [value, setValue] = useState<string>(options[0]);

  const handleClick = (e: any) => {
    if (e.value === null) {
      return
    }
    setValue(e.value);
    console.log(e.value);
    setEncodeOn(e.value === 'Encode' ? true : false);
    handleEncodeDecodeSwitch();
  }

  return (
    <div>
      <SelectButton value={value} onChange={(e: any) => handleClick(e)} options={options} />
    </div>
  )
}

export default SubmitButton